import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
import { ToastsStore } from 'react-toasts';
import * as types from './types';
import * as globalTypes from '../../globalTypes';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* patchBuyingMomentsWatcherSaga() {
  yield takeEvery(types.UPDATE_BUYING_MOMENTS_API_CALL_REQUEST, workerSaga);
}

export function patchData(data) {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/offer/${client}/buying-moment/${data.id}/`;

  return axios.patch(url, data)
    .then(val => val)
    .catch(err => err.response);
}

export function* workerSaga(action) {
  try {
    const updatedData = action.data;
    const response = yield call(patchData, updatedData);

    if (response && response.status === 200) {
      const { data } = response;
      yield put({ type: types.UPDATE_BUYING_MOMENTS_API_CALL_SUCCESS, data, oldBMId: updatedData.id });

      ToastsStore.success('Buying moment has been updated successfully.');

      yield put({ type: globalTypes.UPDATE_SIDE_DRAWER_STATE, open: false });
      yield put({ type: types.RESET_BUYING_MOMENT_TO_DEFAULT });
    } else {
      yield put({ type: types.UPDATE_BUYING_MOMENTS_API_CALL_FAILURE, error: response.data });
    }
  } catch (error) {
    yield put({ type: types.UPDATE_BUYING_MOMENTS_API_CALL_FAILURE, error });
  }
}
